import sharedMutations from "@/store/utils/shared-mutations";

const addUserDetail = (state, values) => {
  state.role = values.role;
  state.freeProfileQuota = values.freeProfileQuota;
  state.isDeleted = values.isDeleted;
  state._id = values._id;
  state.username = values.username;
  state.email = values.email;
};

export default {
  addUserDetail,
  ...sharedMutations
};
